import type { APIMe } from '@jojotique/server'
import { loadMe, testMe } from '@service/security.ts'
import { b } from '@utils/build.ts'
import { getLocalData, setLocalData } from '@utils/storage.ts'
import { notify } from '@utils/notify.ts'
import { getTargets } from '@utils/getMenuListItems.ts'
import { env } from '@utils/env.ts'

export let me: APIMe | null = null

const updateNavbar = () => {
  const navbar = document.querySelector('nav menu')
  navbar!.querySelector('li:last-child')?.remove()

  let url = new URL(getTargets('dashboard', false) + '/account')
  navbar!.appendChild(
    b('li', document, {
      children: [
        b('a', document, {
          attrs: { class: 'neon-text-primary', href: url.toString() },
          text: 'Mon profil',
        }),
      ],
    }),
  )

  url = new URL(env('VITE_BACK', false) + '/logout')
  url.searchParams.set('redirectTo', encodeURIComponent(window.location.href))
  navbar!.appendChild(
    b('li', document, {
      children: [
        b('a', document, {
          attrs: { class: 'neon-text-primary', href: url.toString(), rel: 'nofollow' },
          text: 'Me déconnecter',
        }),
      ],
    }),
  )
}

const updateLoginURL = () => {
  if (window.location.href.includes('/login')) return

  const login = document.querySelector('a[href$="/login"]')
  if (!login) return

  const url = new URL(login.getAttribute('href')!)
  url.searchParams.set('redirectTo', encodeURIComponent(window.location.href))
  login.setAttribute('href', url.toString())
}

const sendTestMeOk = () => {
  document.dispatchEvent(new Event('test-me-ok'))
}

document.addEventListener('navbar-init', async () => {
  updateLoginURL()

  me = getLocalData<APIMe>('me')

  if (me) {
    try {
      await testMe()
      updateNavbar()
    } catch (error) {
      notify('Votre session est terminée, vous avez été déconnecté')
    }

    sendTestMeOk()
    return
  }

  me = await loadMe()

  if (me) {
    setLocalData('me', me)
    updateNavbar()
  }

  sendTestMeOk()
})
